module.exports = __webpack_public_path__ + "static/media/S1N5-6.022e148b.svg";